import React, { useState, useEffect } from "react"
import NavbarStyles from "./navbar-styles"
import { Drawer, Menu, Space } from "antd"
import { Link } from "gatsby"
import Logo from "../../../images/logo.png"

const Navbar = ({ navLinks }) => {
  const [visible, setVisible] = useState(false)
  const [showLoginField, setshowLoginField] = useState(false)

  const showDrawer = () => {
    setVisible(true)
  }

  const onClose = () => {
    setVisible(false)
  }

  const logout = () => {
    localStorage.removeItem("auth")
    setshowLoginField(false)
  }

  useEffect(() => {
    if (localStorage.getItem("auth") !== null) {
      setshowLoginField(true)
    } else {
      setshowLoginField(false)
    }
  }, [showLoginField])

  return (
    <NavbarStyles>
      <header>
        <Link to="/">
          <img src={Logo} alt="logo" className="logo" />
        </Link>
        <nav>
          <ul className="nav-area">
            {navLinks.map(item => (
              <li key={item.ID}>
                <Link to={item.slug === "home" ? "/" : `/${item.slug}`}>
                  <a>{item.title}</a>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="btn-area">
          <Space>
            <Link to="/contact">
              <div className="btn-contact">Contact Us</div>
            </Link>
            {showLoginField === false ? (
              <Link to="/login">
                <div className="btn-login">Log In</div>
              </Link>
            ) : (
              <div className="btn-login" onClick={logout}>
                Logout
              </div>
            )}
          </Space>
        </div>
        <a href="#" className="barsMenu" onClick={showDrawer}>
          |||
        </a>
      </header>
      <Drawer
        title="Pauletta"
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        className="custom-drawer"
      >
        <Menu
          defaultSelectedKeys={["1"]}
          defaultOpenKeys={["sub1"]}
          mode="inline"
          onClick={() => onClose()}
        >
          {navLinks.map(item => (
            <Menu.Item key={item.ID}>
              <Link to={item.slug === "home" ? "/" : `/${item.slug}`}>
                <a>{item.title}</a>
              </Link>
            </Menu.Item>
          ))}
          <Menu.Item>
            <Link to="/login">
              <a>Login</a>
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/contact">
              <a>Contact Us</a>
            </Link>
          </Menu.Item>
        </Menu>
      </Drawer>
    </NavbarStyles>
  )
}

export default Navbar
